module.exports = __webpack_public_path__ + "img/towd_5.2c2c28e2.jpg";